export function updateMarkdownMediaSize(
    inputString: string,
    uniqueId: string,
    offset: number,
    isVideo = false,
  ) {
    // Regex to find the pattern ![uniqueId](url,size,fileId)
    const pattern = new RegExp(`${isVideo ? '#' : '!'}\\[${uniqueId}\\]\\(([^,]+),(\\d+),(.*)\\)`, 'g');

    // Replace the size parameter by adding the offset
    const updatedString = inputString.replace(pattern, (match, url, size, fileId) => {
      const newSize = parseInt(size, 10) + offset;
      return `${isVideo ? '#' : '!'}[${uniqueId}](${url},${newSize},${uniqueId})`;
    });

    return updatedString;
  }